<template>
	<div>
		<input type="file" id="file-input" @change="onChange" multiple />
		<label for="file-input" class="unit input-icon"><i class="icon-sf-search" /></label>
		<div class="w-100 pr-4">
			<span class="file-upload__item mr-3" v-for="(file, index) in fileNames" :key="index">
				<span class="file-upload__item__name">{{ file }}</span>
				<i class="icon-sf-circle-close" @click="() => deleteFile(index)" />
			</span>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			fileNames: [],
			fileList: []
		};
	},
	methods: {
		onChange({ target: { files } }) {
			for (const file of files) {
				this.fileNames.push(file.name);
				this.fileList.push(file);
			}
		},
		deleteFile(index) {
			this.fileNames.splice(index, 1);
			this.fileList.splice(index, 1);
		}
	}
};
</script>

<style lang="scss" scoped>
.file-upload__item {
	color: var(--color-info-text);
	&::before {
		content: '\e839';
		font-family: fontello;
		font-weight: bolder;
		margin: 0 4px;
		color: var(--color-default);
	}

	&:hover {
		font-weight: bolder !important;
	}
	& > .file-upload__item__name:hover {
		text-decoration: underline;
	}
	& > .icon-sf-circle-close {
		margin: 0 8px;
		font-size: 5px;
		color: var(--color-error);
		cursor: pointer;

		&:hover {
			font-size: 12px;
		}
	}
}
input[type='file'] {
	display: none !important;
}
</style>
